import { useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";
import { AdminNavbar } from "./AdminNavbar";
import { AdminSidebar } from "./AdminSidebar";

const AdminPanel = () => {
  const isNonMobile = useMediaQuery("(min-width: 600px)");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  return (
    <Box display={isNonMobile ? "flex" : "block"} width="100%" height="100%">
      <AdminSidebar
        isNonMobile={isNonMobile}
        drawerWidth="250px"
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />
      {/* minWidth:0 lets this flex child shrink below its content's
          intrinsic width. Without it, a wide child (the resources table)
          stretches the column past the viewport and the whole page scrolls
          sideways — carrying the navbar with it. The overflow now belongs
          to the content area, so the header stays put and only the panel
          beneath it scrolls. */}
      <Box flexGrow={1} minWidth={0} display="flex" flexDirection="column">
        <AdminNavbar
          isNonMobile={isNonMobile}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <Box sx={{ flexGrow: 1, minWidth: 0, overflowX: "auto" }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default AdminPanel;
